// extracted by mini-css-extract-plugin
module.exports = {"SparkChart":"SparkChart_SparkChart__nGVrb","no-chart":"SparkChart_no-chart__EUDZ4"};